import { ComboType } from '@shared/enums';
import starImgUrl from '../../../assets/star.png';
import moonImgUrl from '../../../assets/moon.png';
import heartImgUrl from '../../../assets/heart.png';
import hufeImgUrl from '../../../assets/hufe.png';
import kleeblattImgUrl from '../../../assets/kleeblatt.png';
import kroneImgUrl from '../../../assets/krone.png';
import flagImgUrl from '../../../assets/fahne.png';
import xImgUrl from '../../../assets/x.png';
import jokerImgUrl from '../../../assets/joker.png';

export const SYM: Record<string, { char: string; color: number; glow: number; textureKey: string; assetUrl: string }> = {
  STAR:      { char: '★', color: 0x7fe8ff, glow: 0x64f2ff, textureKey: 'sym-star',      assetUrl: starImgUrl },
  MOON:      { char: '☾', color: 0xa676ff, glow: 0xc7a2ff, textureKey: 'sym-moon',      assetUrl: moonImgUrl },
  HORSESHOE: { char: '∪', color: 0xc5b1ff, glow: 0xe2d6ff, textureKey: 'sym-hufe',      assetUrl: hufeImgUrl },
  HEART:     { char: '♥', color: 0xff2938, glow: 0xff6b76, textureKey: 'sym-heart',     assetUrl: heartImgUrl },
  CROWN:     { char: '♛', color: 0xf8cd3b, glow: 0xffe07e, textureKey: 'sym-krone',     assetUrl: kroneImgUrl },
  CLOVER:    { char: '♣', color: 0x4be55b, glow: 0x8dff94, textureKey: 'sym-kleeblatt', assetUrl: kleeblattImgUrl },
};

export const SPECIAL_FLAG_TEXTURE_KEY  = 'sym-flag-final';
export const SPECIAL_X_TEXTURE_KEY    = 'sym-x-final';
export const SPECIAL_JOKER_TEXTURE_KEY = 'sym-joker-combo';

export const SPECIAL_FLAG_ASSET_URL  = flagImgUrl;
export const SPECIAL_X_ASSET_URL    = xImgUrl;
export const SPECIAL_JOKER_ASSET_URL = jokerImgUrl;

export const INPUT_HIT_ALPHA = 0.001;

export const COMBO_LABELS: Record<string, string> = {
  THREE_CLOVERS:    '3 Kleeblätter',
  THREE_MOONS:      '3 Monde',
  THREE_HEARTS:     '3 Herzen',
  THREE_STARS:      '3 Sterne',
  THREE_CROWNS:     '3 Kronen',
  THREE_HORSESHOES: '3 Hufen',
  ONE_PAIR:         '2 Gleiche',
  JOKER:            'Joker',
  FULL_HOUSE:       'Full House',
  FIVE_DIFFERENT:   '5 Versch.',
  FOUR_OF_A_KIND:   '4 Gleiche',
  FIVE_OF_A_KIND:   '5 Gleiche',
};

/** Combos whose preview icons rotate through all symbols */
export const GENERIC_COMBOS: ComboType[] = [
  ComboType.ONE_PAIR,
  ComboType.FULL_HOUSE,
  ComboType.FOUR_OF_A_KIND,
  ComboType.FIVE_OF_A_KIND,
];
